import { styled } from '@mui/material/styles';

export const PhoneIconButton = styled('div')(() => ({
    backgroundColor: 'rgba(145, 158, 171, 0.08)',
    borderRadius: 12,
    width: 36,
    height: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
}));
export const followUpBoxStyle = {
    p: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: { md: '95%', xs: '98%' },
    mx: 'auto',
    flex: 1,
    height: '100%',
};
export const followUpTitleStyle = {
    textAlign: 'center',
    marginBottom: 0,
    fontSize: 'clamp(1.1rem, 0.85rem + 1.25vw, 1.75rem)',
    fontWeight: 400,
    letterSpacing: '-0.02em',
    lineHeight: 1.3,
    color: '#637381'
};
export const followUpSubTitleStyle = {
    textAlign: 'center',
    color: '#919EAB',
    fontSize: '13px',
    mb: 0,
    display: 'flex',
    justifyContent: 'center',
    fontStyle: 'italic',
    lineHeight: 1.5
};
export const followUpCardStyle = {
    p: { sm: 3, xs: 2 },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: 'none',
    maxWidth: '100%',
    width: '100%',
    padding: '0 !important',
    borderRadius: 0
};
export const numberLinkStyle = {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    marginBottom: '40px',
    maxWidth: '100%',
    padding: '16px 24px',
};
export const numberTextStyle = {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 'clamp(1.25rem, 0.9rem + 1.5vw, 2rem)',
    fontWeight: 600,
    letterSpacing: '-0.01em'
};
export const callScriptButtonStyle = {
    borderRadius: '16px',
    border: '1px solid rgba(145, 158, 171, 0.16)',
    boxShadow: '0 2px 8px rgba(145, 158, 171, 0.08)',
    width: '195px',
    height: '56px',
    color: '#637381',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    '&:hover': {
        boxShadow: '0 4px 16px rgba(145, 158, 171, 0.16)',
        borderColor: 'rgba(145, 158, 171, 0.24)'
    }
};
export const textStyle = {
    textAlign: { xs: 'center' },
    marginTop: { lg: '0', md: '0' },
    marginBottom: { md: '16px', xs: '12px' }
};
export const buttonGroupStyle = {
    border: '1px solid transparent',
    backgroundImage: 'linear-gradient(#f9fafb, #f9fafb), linear-gradient(135deg, #5BE584 0%, #00A76F 25%, #007867 50%, #00A76F 75%, #5BE584 100%)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    backgroundSize: '100% 100%, 300% 300%',
    animation: 'outcomeGlow 4s ease infinite',
    '@keyframes outcomeGlow': {
        '0%': { backgroundPosition: '0% 0%, 0% 50%' },
        '50%': { backgroundPosition: '0% 0%, 100% 50%' },
        '100%': { backgroundPosition: '0% 0%, 0% 50%' },
    },
    boxShadow: '0 2px 12px rgba(0, 167, 111, 0.1)',
    flexDirection: { md: 'row', xs: 'column' },
    maxWidth: '100%',
    width: '100%',
    borderRadius: '20px',
    padding: '6px'
};

const baseOutcomeButtonStyle = (isActive) => ({
    backgroundColor: isActive ? 'rgba(0, 171, 85, 0.08)' : 'transparent',
    ':hover': {
        backgroundColor: 'rgba(0, 171, 85, 0.06)',
        color: '#00AB55',
        border: 'none',
        boxShadow: isActive ? '0 2px 8px rgba(0, 171, 85, 0.12)' : 'none'
    },
    borderRadius: '14px !important',
    color: isActive ? '#00AB55' : '#637381',
    border: 'none',
    fontSize: '14px',
    fontWeight: isActive ? 600 : 500,
    boxShadow: isActive ? '0 1px 4px rgba(0, 171, 85, 0.08)' : 'none',
    padding: { md: '14px 20px', xs: '12px 16px' },
    justifyContent: { xs: 'flex-start' },
    textAlign: 'left',
    textTransform: 'none !important',
    transition: 'all 0.2s ease'
});

export const unableContactButtonStyle = (outcome) => ({
    ...baseOutcomeButtonStyle(outcome === 'Unable to contact'),
    margin: '0 !important',
    marginRight: { md: '4px', xs: '0' },
});
export const appointmentButtonStyle = (outcome) => ({
    ...baseOutcomeButtonStyle(outcome === 'Appointment Not Booked'),
    marginRight: { md: '4px', xs: '0' },
});
export const bookingButtonStyle = (outcome) => ({
    ...baseOutcomeButtonStyle(outcome === 'Booking Details'),
});

export const spamButtonStyle = (outcome) => ({
    backgroundColor: outcome === 'spam' ? 'rgba(255, 86, 48, 0.08)' : 'transparent',
    ':hover': {
        backgroundColor: 'rgba(255, 86, 48, 0.06)',
        color: '#FF5630',
        border: 'none',
        boxShadow: outcome === 'spam' ? '0 2px 8px rgba(255, 86, 48, 0.12)' : 'none'
    },
    borderRadius: '14px !important',
    color: outcome === 'spam' ? '#FF5630' : '#637381',
    border: 'none',
    fontSize: '14px',
    fontWeight: outcome === 'spam' ? 600 : 500,
    boxShadow: outcome === 'spam' ? '0 1px 4px rgba(255, 86, 48, 0.08)' : 'none',
    padding: { md: '14px 20px', xs: '12px 16px' },
    justifyContent: { xs: 'flex-start' },
    textAlign: 'left',
    textTransform: 'none !important',
    transition: 'all 0.2s ease',
    margin: '0 !important',
    marginRight: { md: '4px', xs: '0' },
});

export const notInterestedButtonStyle = (outcome) => ({
    backgroundColor: outcome === 'not_interested' ? 'rgba(145, 158, 171, 0.08)' : 'transparent',
    ':hover': {
        backgroundColor: 'rgba(145, 158, 171, 0.06)',
        color: '#637381',
        border: 'none',
        boxShadow: outcome === 'not_interested' ? '0 2px 8px rgba(145, 158, 171, 0.12)' : 'none'
    },
    borderRadius: '14px !important',
    color: outcome === 'not_interested' ? '#637381' : '#637381',
    border: 'none',
    fontSize: '14px',
    fontWeight: outcome === 'not_interested' ? 600 : 500,
    boxShadow: outcome === 'not_interested' ? '0 1px 4px rgba(145, 158, 171, 0.08)' : 'none',
    padding: { md: '14px 20px', xs: '12px 16px' },
    justifyContent: { xs: 'flex-start' },
    textAlign: 'left',
    textTransform: 'none !important',
    transition: 'all 0.2s ease',
    marginRight: { md: '4px', xs: '0' },
});

export const separatorStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    my: '12px',
    mx: '4px',
};

export const separatorLineStyle = {
    flex: 1,
    height: '1px',
    background: '#e8eaed',
};

export const separatorTextStyle = {
    fontSize: '10px',
    color: '#919EAB',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
};

export const nonContactButtonStyle = (isSelected) => ({
    justifyContent: 'flex-start',
    textTransform: 'none',
    py: 1,
    px: 1.5,
    borderRadius: '10px',
    border: '1.5px solid',
    borderColor: isSelected ? '#637381' : '#e0e0e0',
    background: isSelected ? 'rgba(145,158,171,0.06)' : '#fff',
    color: '#212B36',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '&:hover': { borderColor: '#919EAB', background: '#fafafa' },
});

export const channelBoxStyle = {
    display: 'flex',
    gap: '16px',
    mb: 1,
};

export const callPromptBoxStyle = {
    background: '#f8f9fa',
    border: '1.5px solid #e8eaed',
    borderRadius: '12px',
    p: 2,
    mb: 2,
};
